module.exports = __webpack_public_path__ + "static/media/buyBlock.b5b99016.png";